var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Date Added") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.85451389,0 C5.396875,0 5.77118056,0.410590278 5.77118056,0.916666667 L5.77118056,2.44444444 L11.3055556,2.44444444 L11.3055556,0.916666667 C11.3055556,0.410590278 11.7142361,0 12.2222222,0 C12.7302083,0 13.1388889,0.410590278 13.1388889,0.916666667 L13.1388889,2.44444444 L14.6666667,2.44444444 C16.0149306,2.44444444 17.1111111,3.53871528 17.1111111,4.88888889 L17.1111111,7.33333333 L1.79895833,7.33333333 L1.79895833,17.1111111 C1.79895833,17.4472222 2.10680556,17.7222222 2.41006944,17.7222222 L10.8663194,17.7222222 C11.3322917,18.4402778 11.9357639,19.0628472 12.6347222,19.5555556 L2.44444444,19.5555556 C1.09427083,19.5555556 0,18.459375 0,17.1111111 L0,4.88888889 C0,3.53871528 1.09427083,2.44444444 2.44444444,2.44444444 L3.97222222,2.44444444 L3.97222222,0.916666667 C3.97222222,0.410590278 4.38090278,0 4.88888889,0 L4.85451389,0 Z M22,14.0555556 C22,17.0920139 19.5364583,19.5555556 16.5,19.5555556 C13.4635417,19.5555556 10.965625,17.0920139 10.965625,14.0555556 C10.965625,11.0190972 13.4635417,8.55555556 16.5,8.55555556 C19.5364583,8.55555556 22,11.0190972 22,14.0555556 Z M15.8545139,11.6111111 L15.8545139,14.0555556 C15.8545139,14.3916667 16.1638889,14.6666667 16.465625,14.6666667 L18.3333333,14.6666667 C18.6694444,14.6666667 18.9444444,14.3916667 18.9444444,14.0555556 C18.9444444,13.7194444 18.6694444,13.4444444 18.3333333,13.4444444 L17.0767361,13.4444444 L17.0767361,11.6111111 C17.0767361,11.275 16.8361111,11 16.465625,11 C16.1638889,11 15.8545139,11.275 15.8545139,11.6111111 L15.8545139,11.6111111 Z",
    id: "calendar"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/outline/calendar_24px",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(1.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-calendar",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#calendar"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#calendar"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Color",
    mask: "url(#mask-calendar)",
    fill: "#34436D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, -2.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 125,
    height: 50
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.bee749bd.svg";
export { ForwardRef as ReactComponent };